<template>
  <div class="map-item-wrapper">
    <el-row :gutter="10" align="middle">
      <el-col :span="4">
        <div class="map-thumb-wrapper">
          <el-image :src="mapPlaceholder" style="border-radius: 4px" />
        </div>
      </el-col>
      <el-col :span="20">
        <div class="card-wrap">
          <div class="map-name">
            <el-text>
              {{ map.name }}
            </el-text>
          </div>
          <div class="card-actions">
            <el-button icon="Delete" link @click="deleteMap" />
            <el-button circle size="small" v-if="map.added_to_map">
              <i
                class="iconfont icon-a-ziyuan41"
                style="color: #fc4c02"
                v-if="map.added_to_map"
              />
            </el-button>
            <el-button circle size="small" v-else @click="addToEarth">
              <i
                class="iconfont icon-a-ziyuan51"
                style="color: #fc4c02; cursor: pointer"
              />
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import mapPlaceholder from '@/assets/images/map-placeholder.png';
import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';

const { track } = useTrack();

export default {
  props: {
    map: Object,
  },
  data() {
    return {
      mapPlaceholder,
    };
  },
  computed: {
    earthLayer() {
      if (this.map.mapType === 'XYZ') {
        return {
          id: this.map.name,
          uid: this.map.name,
          layerServiceInfo: {
            url: this.map.url,
          },
        };
      } else if (this.map.mapType === 'WMS') {
        return {
          id: this.map.name,
          uid: this.map.name,
          url: this.map.wms.url.onlineResource,
          type: 'wms',
          options: {
            layers: this.map.wms.layer.identifier,
          },
        };
      } else {
        return {
          id: this.map.name,
          uid: this.map.name,
          url: this.map.wmts.url.slippy.replaceAll(/\{s\}/g, '1'),
          type: 'wmts',
          options: {
            layer: this.map.wmts.layer[0].identifier,
            style: 'default',
            format: this.map.wmts.layer[0].format,
            tileMatrixSetID: this.map.wmts.layer[0].tileMatrixSets[0],
            // subdomains: ['0','1','2','3','4','5','6','7','8','9']
          },
        };
      }
    },
  },
  methods: {
    addToEarth() {
      this.$store.dispatch('importMaps/addToEarth', this.map);
      if (this.map.mapType === 'XYZ') {
        this.$EventBus.emit('globalcheckedLayer', this.earthLayer);
      } else {
        this.$EventBus.emit('globalcheckedWMTSLayer', this.earthLayer);
      }

      track(
        FunctionIdEnum.globalLayer_layers_addHistoricalConnection,
        EventTypeEnum.CLICK,
        {
          layerName: this.map.name,
          url: this.map.url,
          layerType: this.map.mapType,
        },
      );
    },

    deleteMap() {
      this.$store.dispatch('importMaps/deleteMap', this.map);

      track(
        FunctionIdEnum.globalLayer_layers_deleteConnection,
        EventTypeEnum.CLICK,
        {
          url: this.map.url,
        },
      );
    },
  },
};
</script>
<style scoped>
.map-item-wrapper {
  border-bottom: 1px solid #ebeef5;
  margin-top: 8px;
  padding-bottom: 5px;
}

.card-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.map-thumb-wrapper {
  text-align: left;
}

.map-name {
  text-align: left;
  flex: 1;
}

.el-card {
  border: 1px solid #fc4c02;
  margin-top: 5px;
}
.el-button {
  margin: 0 5px 0 0 !important;
}
.card-actions {
  width: 100px;
  text-align: right;
}
</style>
